module.exports = __webpack_public_path__ + "assets/img/cc20-nf.svg";